// extracted by mini-css-extract-plugin
export default {"table":"PieAndTable_table__qpQJS","dot":"PieAndTable_dot__6BEYg"};